<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div
        class="page-header d-md-flex justify-content-between align-items-center mb-4"
      >
        <div>
          <h3 class="page-title text-dark font-weight-bold mb-1">
            Quản lý Danh mục
          </h3>
          <ul class="breadcrumb bg-transparent p-0 m-0">
            <li class="breadcrumb-item">
              <a href="/" class="text-muted text-decoration-none">Dashboard</a>
            </li>
            <li class="breadcrumb-item active">Danh mục báo cáo</li>
          </ul>
        </div>
        <div class="mt-3 mt-md-0">
          <button
            class="btn btn-primary btn-add shadow-sm"
            @click="openModal('add')"
          >
            <i class="fa fa-plus mr-2"></i> Thêm Danh mục
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover mb-0 custom-table align-middle">
                  <thead class="bg-light">
                    <tr>
                      <th
                        class="py-3 pl-4 border-0 text-secondary text-uppercase font-size-sm"
                        style="width: 50px"
                      >
                        #
                      </th>
                      <th
                        class="py-3 border-0 text-secondary text-uppercase font-size-sm"
                      >
                        Tên Danh Mục
                      </th>
                      <th
                        class="py-3 border-0 text-secondary text-uppercase font-size-sm"
                        style="width: 30%"
                      >
                        Mô Tả
                      </th>
                      <th
                        class="py-3 border-0 text-secondary text-uppercase font-size-sm text-center"
                      >
                        Ẩn danh
                      </th>
                      <th
                        class="py-3 border-0 text-secondary text-uppercase font-size-sm text-center"
                      >
                        Ưu tiên
                      </th>
                      <th
                        class="py-3 border-0 text-secondary text-uppercase font-size-sm text-center"
                      >
                        Trạng thái
                      </th>
                      <th
                        class="py-3 pr-4 border-0 text-secondary text-uppercase font-size-sm text-right"
                      >
                        Hành động
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="listDanhMuc.length === 0">
                      <td colspan="7" class="text-center py-5 text-muted">
                        <i
                          class="fa fa-folder-open-o fa-3x mb-3 text-light-gray"
                        ></i>
                        <p>Chưa có danh mục nào được tạo.</p>
                      </td>
                    </tr>
                    <tr v-for="(item, index) in listDanhMuc" :key="item.id">
                      <td class="pl-4 text-muted font-weight-bold">
                        {{ index + 1 }}
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-shape icon-sm bg-light-primary text-primary mr-3 rounded"
                          >
                            <i class="fa fa-folder"></i>
                          </div>
                          <span class="font-weight-bold text-dark">{{
                            item.tenDanhMuc
                          }}</span>
                        </div>
                      </td>
                      <td class="text-muted text-truncate-multiline small">
                        {{ item.moTa || "---" }}
                      </td>
                      <td class="text-center">
                        <span
                          class="status-pill"
                          :class="
                            item.choPhepAnDanh
                              ? 'pill-success'
                              : 'pill-disabled'
                          "
                        >
                          <i
                            :class="
                              item.choPhepAnDanh
                                ? 'fa fa-check-circle'
                                : 'fa fa-times-circle'
                            "
                          ></i>
                          {{ item.choPhepAnDanh ? "Cho phép" : "Không" }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-light border">{{
                          item.thuTuUuTien
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span
                          class="dot-status"
                          :class="item.kichHoat ? 'bg-success' : 'bg-danger'"
                        ></span>
                        <span
                          :class="
                            item.kichHoat ? 'text-success' : 'text-danger'
                          "
                          class="font-weight-medium small ml-2"
                        >
                          {{ item.kichHoat ? "Hoạt động" : "Đã ẩn" }}
                        </span>
                      </td>
                      <td class="text-right pr-4">
                        <button
                          class="btn btn-icon btn-light btn-sm mr-2"
                          @click="openModal('edit', item)"
                          title="Chỉnh sửa"
                        >
                          <i class="fa fa-pencil text-info"></i>
                        </button>
                        <button
                          class="btn btn-icon btn-light btn-sm"
                          @click="handleDelete(item)"
                          title="Xóa"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="custom-modal-backdrop">
      <div class="custom-modal-dialog">
        <div class="modal-content border-0">
          <div class="modal-header border-bottom-0 pb-0">
            <h5 class="modal-title font-weight-bold text-dark">
              {{
                modalMode === "add" ? "Thêm Danh Mục Mới" : "Cập Nhật Danh Mục"
              }}
            </h5>
            <button type="button" class="close-btn" @click="closeModal">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body pt-4">
            <form @submit.prevent="handleSubmit">
              <div class="form-group mb-4">
                <label class="form-label"
                  >Tên Danh Mục <span class="text-danger">*</span></label
                >
                <input
                  v-model="form.tenDanhMuc"
                  type="text"
                  class="form-control modern-input"
                  placeholder="Nhập tên danh mục..."
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label class="form-label">Mô Tả</label>
                <textarea
                  v-model="form.moTa"
                  class="form-control modern-input"
                  rows="3"
                  placeholder="Mô tả ngắn gọn về danh mục này..."
                ></textarea>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-4">
                    <label class="form-label">Thứ tự ưu tiên</label>
                    <input
                      v-model.number="form.thuTuUuTien"
                      type="number"
                      class="form-control modern-input"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mt-1">
                    <label class="form-label d-block mb-2">&nbsp;</label>
                    <label
                      class="custom-control custom-switch d-flex align-items-center cursor-pointer"
                    >
                      <input
                        v-model="form.choPhepAnDanh"
                        type="checkbox"
                        class="custom-control-input"
                      />
                      <span class="custom-control-label font-weight-medium"
                        >Cho phép Ẩn danh</span
                      >
                    </label>
                  </div>
                </div>
              </div>

              <div
                v-if="modalMode === 'edit'"
                class="form-group bg-light p-3 rounded mb-4"
              >
                <label
                  class="custom-control custom-checkbox cursor-pointer mb-0"
                >
                  <input
                    v-model="form.kichHoat"
                    type="checkbox"
                    class="custom-control-input"
                  />
                  <span class="custom-control-label text-dark font-weight-bold"
                    >Kích hoạt (Hiển thị)</span
                  >
                </label>
              </div>

              <div class="modal-footer border-top-0 px-0 pb-0">
                <button
                  type="button"
                  class="btn btn-light px-4 mr-2"
                  @click="closeModal"
                >
                  Hủy
                </button>
                <button class="btn btn-primary px-4 shadow-sm" type="submit">
                  {{ modalMode === "add" ? "Tạo mới" : "Lưu thay đổi" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import baoCaoService from "@/services/gopYKienNghiService";
import { useToast } from "vue-toastification";
import Swal from "sweetalert2";

const toast = useToast();
const listDanhMuc = ref([]);
const showModal = ref(false);
const modalMode = ref("add"); // 'add' or 'edit'

const form = reactive({
  id: null,
  tenDanhMuc: "",
  moTa: "",
  choPhepAnDanh: false,
  thuTuUuTien: 1,
  kichHoat: true,
});

const fetchData = async () => {
  try {
    const res = await baoCaoService.getAllDanhMucAdmin();
    listDanhMuc.value = res.data;
  } catch (error) {
    console.error(error);
    toast.error("Lỗi tải danh sách danh mục");
  }
};

const openModal = (mode, item = null) => {
  modalMode.value = mode;
  if (mode === "edit" && item) {
    Object.assign(form, item);
  } else {
    // Reset form
    form.id = null;
    form.tenDanhMuc = "";
    form.moTa = "";
    form.choPhepAnDanh = false;
    form.thuTuUuTien = 1;
    form.kichHoat = true;
  }
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};

const handleSubmit = async () => {
  try {
    if (modalMode.value === "add") {
      await baoCaoService.createDanhMuc(form);
      toast.success("Thêm mới thành công!");
    } else {
      await baoCaoService.updateDanhMuc(form.id, form);
      toast.success("Cập nhật thành công!");
    }
    closeModal();
    fetchData();
  } catch (error) {
    toast.error(error.response?.data?.message || "Có lỗi xảy ra");
  }
};

const handleDelete = async (item) => {
  const result = await Swal.fire({
    title: "Xác nhận xóa?",
    text: `Bạn muốn xóa (ẩn) danh mục "${item.tenDanhMuc}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Đồng ý xóa",
    cancelButtonText: "Hủy",
  });

  if (result.isConfirmed) {
    try {
      await baoCaoService.deleteDanhMuc(item.id);
      toast.success("Đã xóa thành công");
      fetchData();
    } catch (error) {
      toast.error("Lỗi khi xóa");
    }
  }
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
/* --- General Page Style --- */
.page-wrapper {
  background-color: #f7f9fc;
  min-height: 100vh;
  padding-bottom: 30px;
}

/* --- Typography & Utils --- */
.font-size-sm {
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}
.text-light-gray {
  color: #e0e0e0;
}
.cursor-pointer {
  cursor: pointer;
}

/* --- Buttons --- */
.btn-add {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s;
}
.btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(74, 108, 247, 0.2);
}

.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid transparent;
  transition: all 0.2s;
}
.btn-icon:hover {
  background-color: #fff;
  border-color: #e0e0e0;
  transform: scale(1.05);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

/* --- Table Styles --- */
.custom-table tbody tr {
  transition: background-color 0.2s;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
}
.custom-table tbody tr:last-child {
  border-bottom: none;
}
.custom-table tbody tr:hover {
  background-color: #fafbfc;
}

.icon-shape {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-light-primary {
  background-color: rgba(74, 108, 247, 0.1);
}

/* Status Pill */
.status-pill {
  padding: 6px 12px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.pill-success {
  background-color: #e6fcf5;
  color: #0ca678;
}
.pill-disabled {
  background-color: #f1f3f5;
  color: #868e96;
}

/* Status Dot */
.dot-status {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}

/* --- Input Styles --- */
.modern-input {
  border: 1px solid #e1e5eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.95rem;
  transition: all 0.2s;
}
.modern-input:focus {
  border-color: #4a6cf7;
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
  outline: none;
}
.form-label {
  font-weight: 600;
  color: #343a40;
  font-size: 0.9rem;
  margin-bottom: 6px;
}

/* --- Modal Styles --- */
.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* Darken slightly */
  backdrop-filter: blur(4px); /* Blur effect */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  transition: opacity 0.3s ease;
}

.custom-modal-dialog {
  background: white;
  border-radius: 12px;
  width: 500px;
  max-width: 95%;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Bouncy effect */
  overflow: hidden;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: #aaa;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #333;
}

@keyframes modalPop {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
